import { CrossSellingPointer } from "../../others";
import { RCB } from ".";
/**
 * Plugins list and headline.
 */

const crossRcbGdprCompliant = () => CrossSellingPointer.waitForVisibleElement("body.wp-admin.plugins-php #wpbody-content > div.wrap > h1:first", RCB, "gdpr-compliant");

export { crossRcbGdprCompliant };